import composeInstallation from '../utils/composeInstallation'
import {
  createTimeoutPromise,
  debouncePromise,
} from '@flamingo_tech/funkgo-utils/promiseUtils'

const installFbSdk = composeInstallation({
  name: 'fb',
  makeScriptUri: () => 'https://connect.facebook.net/en_US/sdk.js'
})

let options

const init = initOptions => options = initOptions

const getClientId = () => options ? options.clientId : undefined

/* ----------------------------- */

const install = debouncePromise(installFbSdk)

const ready = debouncePromise(() => {
  const clientId = getClientId()

  if (!clientId) {
    throw new Error(`[fbSdk] cannot got clientId, make sure call init() before any bridges call`)
  }

  if (window.FB) {
    return Promise.resolve(window.FB)
  }

  return install().then(() => (
    createTimeoutPromise(resolve => {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: clientId,
          autoLogAppEvents: false,
          xfbml: false,
          version: 'v6.0'
        });

        resolve(window.FB)
      }
    }, 10000, `fbSdk:install`)
  ))
})


/* ----------------------------- */


const DEFAULT_BRIDGE_TIMEOUT = 1000 * 30
const LOGIN_BRIDGE_TIMEOUT = 1000 * 60 * 3

const mapFbCallBackToPromise = name => (...args) => {
  return ready().then(FB => {
    const isLogin = name === 'login'
    const timeout = isLogin ? LOGIN_BRIDGE_TIMEOUT : DEFAULT_BRIDGE_TIMEOUT

    return createTimeoutPromise((resolve, reject) => {
      const callback = result => {
        if (result && result.error) {
          reject(result.error)
        } else {
          resolve(result)
        }
      }

      const payloadArgs = isLogin
        ? [callback, ...args]
        : [...args, callback]

      return FB[name].call(FB, ...payloadArgs)
    }, timeout, `fbSdk:${name}`)
  })
}

/* ----------------------------- */

const methodsMap = [
  'getLoginStatus',
  'login',
  'logout',
  'api',
  'ui'
]

const bridges = {}
methodsMap.forEach(name => {
  bridges[name] = mapFbCallBackToPromise(name)
})

export {
  init,
  install,
  bridges,
  getClientId,
}